import styled from '@emotion/styled';
import { fontSize, ContentWrapper } from '@styles/globalStyles';
import { breakpoint } from '@styles/breakpoints';

export const SectionHeader = styled.h3`
  color: #ffffff !important;
  font-size: 24px;
  text-transform: uppercase;
  background-color: #000000;
  display: inline-block;
  font-weight: 700;
  padding: 3px 5px;
`;

export const Container = styled(ContentWrapper)`
  padding: 72px 0px;

  h2 {
    margin-bottom: 72px;
    font-weight: 400;
    // font-family: ${({ theme }) => theme.defaults.fontFamily.primary};
    color: #00202d;
  }

  h3 {
    font-family: ${({ theme }) => theme.defaults.fontFamily.primary};
    color: #00202d;
  }

  // & div:last-of-type {
  //   margin-bottom: 0px;

  //   h3:first-of-type {
  //     color: #00405b;
  //   }

  //   h3:nth-of-type(2) {
  //     color: #e6007e;
  //   }
  // }

  @media only screen and (max-width: 1350px) {
    padding: 72px 15px;
  }

  @media only screen and ${breakpoint.lg} {
    padding: 32px 15px;

    h2 {
      font-size: ${fontSize(32)};
      margin-bottom: 20px;
    }
  }

  @media only screen and ${breakpoint.md} {
    h2 {
      font-size: ${fontSize(24)};
    }
  }
`;

export const Assumption = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.type === 'rtl' ? 'row' : 'row-reverse')};
  gap: 32px;
  margin-bottom: 72px;
  color: #00202d;

  @media only screen and ${breakpoint.lg} {
    display: block;
    margin-bottom: 32px;
  }
`;

export const Content = styled.div`
  width: 50%;

  // & h3:first-of-type {
  //   color: #e6007e;
  // }

  span {
    font-weight: bold;
  }

  @media only screen and ${breakpoint.lg} {
    width: 100%;
    h3 {
      font-size: ${fontSize(24)};
    }

    .last-assumption {
      display: none;
    }
  }
`;

export const MobileImage = styled.div`
  width: 100%;
  height: fit-content;
  display: none;
  text-align: center;
  margin-bottom: 20px !important;

  @media only screen and ${breakpoint.lg} {
    display: block;
  }
`;

export const Description = styled.p<{ colorStrong?: boolean }>`
  font-size: ${fontSize(16)};
  font-weight: 400;
  line-height: 1.71;
  letter-spacing: -0.21px;
  color: #00202d;
  margin: 24px 0 32px 0;

  a,
  a:hover,
  a:visited {
    color: #009fe3;
    font-size: ${fontSize(15)};
    font-weight: 500;
    line-height: 1.71;
    letter-spacing: -0.21px;
  }

  b {
    font-weight: 700;
  }

  ${(props) =>
    props.colorStrong &&
    `
    strong {
      color: #009fe3;
      display: block;
    }
  `}

  @media only screen and ${breakpoint.lg} {
    margin: 12px 0 24px;
  }
`;

export const DescriptionList = styled.ul`
  font-size: ${fontSize(16)};
  font-weight: 400;
  line-height: 1.71;
  letter-spacing: -0.21px;
  color: #00202d;
  margin: 24px 0 32px 20px;
  list-style: disc;

  li {
    & + li {
      margin-top: 16px;
    }

    &::marker {
      color: #009fe3;
      font-size: 18px;
    }
  }

  a,
  a:hover,
  a:visited {
    color: #009fe3;
    font-size: ${fontSize(15)};
    font-weight: 500;
    line-height: 1.71;
    letter-spacing: -0.21px;
  }

  @media only screen and ${breakpoint.lg} {
    margin: 12px 0 24px;
  }
`;

export const ImageContainer = styled.div`
  width: 50%;
  height: fit-content;

  @media only screen and ${breakpoint.lg} {
    width: 100%;
    text-align: center;
  }
`;

export const HorizontalRule = styled.div`
  width: 100%;
  height: 1px;
  background-color: #009fe3;
`;

export const InformationContainer = styled(ContentWrapper)`
  padding: 72px 0;
  display: flex;
  gap: 32px;

  @media only screen and (max-width: 1350px) {
    padding: 72px 15px;
  }

  @media only screen and ${breakpoint.lg} {
    padding: 32px 15px;
  }

  @media only screen and ${breakpoint.md} {
    display: block;
  }
`;
export const Information = styled.div`
  width: 50%;

  h3 {
    font-family: ${({ theme }) => theme.defaults.fontFamily.primary};
  }

  @media only screen and ${breakpoint.md} {
    width: 100%;
  }
`;
